<template lang="pug">
.container-fluid
	.card
		.card-header.bg-info.text-white
			span.fa.fa-search.mr-2
			|Filtrar usuarios
		.card-body
			.row
				.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3
					.form-group
						label Nombre/apellidos
						input.form-control(type="text" v-model="filtro.nombre" placeholder="Busca por nombre o apellidos" @keypress.enter="buscar()")
				.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3
					.form-group
						label Grupo
						br
						select.form-control(v-model="filtro.grupo" @change="setGrupo(filtro.grupo)")
							option(:value="null") Selecciona
							option(v-for="grupo in grupos" :key="grupo.nombre" :value="grupo.nombre") {{grupo.nombre}}
				.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3
					.form-group
						label Sexo
						br
						.btn-group
							button.btn(:class="(filtro.sexo === 'hombre') ? 'btn-primary' : 'btn-default'" @click="setSexo('hombre')")
								|Hombre
							button.btn(:class="(filtro.sexo === 'mujer') ? 'btn-primary' : 'btn-default'" @click="setSexo('mujer')")
								|Mujer
							button.btn(:class="(filtro.sexo === null) ? 'btn-primary' : 'btn-default'" @click="setSexo(null)")
								|Cualquiera
				.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3
					.form-group
						label Estado
						br
						.btn-group
							button.btn(:class="(filtro.activo === true) ? 'btn-primary' : 'btn-default'" @click="setActivo(true)")
								|Activo
							button.btn(:class="(filtro.activo === false) ? 'btn-primary' : 'btn-default'" @click="setActivo(false)")
								|Inactivo
							button.btn(:class="(filtro.activo === null) ? 'btn-primary' : 'btn-default'" @click="setActivo(null)")
								|Cualquiera
		.card-footer
			.row
				.col.text-left
					button.btn.btn-sm.btn-primary(@click="buscar()")
						span.fa.fa-search.mr-2
						|Buscar
				.col.text-right
					button.btn.btn-sm.btn-warning(@click="editar = 'nuevo'")
						span.fa.fa-edit.mr-2
						|Nuevo
	.card.mt-2
		.table-responsive
			table.table.table-condensed.table-striped.m-0.text-left
				thead.bg-dark.text-white
					tr
						th ID
						th Avatar
						th Usuario
						th Nombre
						th Sexo
						th Estado
						th
				tbody
					tr(v-for="usuario in listadoUsuarios" :key="usuario.ID" :class="(!usuario.activo) ? 'inactivo' : ''")
						td(style="width:80px;vertical-align:middle;") {{usuario.ID}}
						td(style="vertical-align:middle;")
							img.rounded-circle(:src="usuario.avatar" v-if="usuario.avatar" style="width:50px;height:50px;")
						td(style="vertical-align:middle;") {{usuario.usuario}}
						td(style="vertical-align:middle;") {{usuario.nombre}} {{usuario.apellidos}}
						td(style="vertical-align:middle;") {{usuario.sexo}}
						td(style="font-size:2em;vertical-align:middle;")
							span.fa.fa-ban(v-if="!usuario.activo")
							span.fa.fa-check(v-if="usuario.activo")
						td.text-center(style="width:60px;vertical-align:middle;")
							button.btn.btn-warning(@click="editar = usuario.ID")
								span.fa.fa-edit.mr-2
								|Editar
				tbody(v-if="listadoUsuarios.length === 0")
					tr
						th.text-center.pt-3.pb-3(colspan="7" style="background-color:white;")
							h3 No hay resultados
	editor-usuario(:idusuario="editar" v-if="editar" @cerrar="editar = null")
</template>

<script>
import API from './api'
import Editor from './editor/editor.vue'

export default {
	components: {
		'editor-usuario': Editor
	},
	data () {
		return {
			filtro: {
				nombre: '',
				sexo: null,
				activo: null,
				grupo: null
			},
			listadoUsuarios: [],
			grupos: [],
			editar: null
		}
	},

	created () {
		this.getGrupos()
		this.buscar()
	},

	methods: {
		getGrupos () {
			API.getGrupos()
				.then(res => {
					this.grupos = res.data.grupos
					console.log(this.grupos)
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		nuevo () {
			this.editar = 'nuevo'
		},
		setSexo (sexo) {
			this.filtro.sexo = sexo
			this.buscar()
		},
		setActivo (activo) {
			this.filtro.activo = activo
			this.buscar()
		},
		setGrupo (grupo) {
			this.filtro.grupo = grupo
			console.log(this.filtro.grupo)
			this.buscar()
		},
		buscar () {
			API.buscar(this.filtro)
				.then(res => {
					this.listadoUsuarios = res.data.usuarios
					console.log(this.listadoUsuarios)
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		}
	}
}
</script>
<style scoped>
	.inactivo {
		opacity: 0.6;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/gestion-usuarios/vue/App.vue